import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Footer() {
  return <footer className="relative overflow-hidden" data-id="element-26">
      {/* CTA Section */}
      <div className="bg-gradient-to-b from-primary-dark via-primary to-primary-dark py-20 md:py-28" data-id="element-27">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-28">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-5xl font-extrabold italic text-white mb-10 leading-tight" data-id="element-29">
            Hacé clic y empezá hoy.
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} data-id="element-30">
            <a href="#comprar" className="inline-flex items-center gap-3 bg-white text-primary font-bold text-lg md:text-xl px-10 py-5 rounded-full shadow-[0_4px_30px_rgba(255,255,255,0.2)] hover:shadow-[0_4px_40px_rgba(255,255,255,0.35)] hover:scale-105 transition-all duration-300" data-id="element-31">
              ACCEDER AHORA
              <ArrowRightIcon className="w-5 h-5" data-id="element-32" />
            </a>
          </motion.div>
        </div>
      </div>

      {/* Bottom legal */}
      <div className="bg-primary-dark py-8" data-id="element-33">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
          <div className="border-t border-gray-700/50 pt-8 text-center space-y-3" data-id="element-35">
            <p className="text-gray-400 text-sm" data-id="element-36">
              © {new Date().getFullYear()} Administración 360. Todos los
              derechos reservados.
            </p>
            <p className="text-gray-500 text-xs leading-relaxed" data-id="element-37">
              Este sitio no forma parte de Facebook o Facebook Inc.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}